// extracted by mini-css-extract-plugin
export default {"overlay":"ModalShell_overlay__9MIxV","panel":"ModalShell_panel__xLsJM","srOnly":"ModalShell_srOnly__TvSGA"};